export class GringottsConstants {
    static readonly userRole = 'user';
    static readonly adminRole = 'admin';
    static readonly appAdminRole = 'appadmin';
    static readonly appUserRole = 'appuser';
    static readonly appManagerRole = 'appmanager';
    static readonly notAvailable = 'Not Available';
}

export class GenericRoles {
    static readonly userRole = "User";
    static readonly appManagerRole = "AppManager";
}